import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Button,
  Checkbox,
  Grid,
  Typography,
  Autocomplete,
  Pagination,
  Skeleton,
  TableContainer,
} from "@material-ui/core";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Logo from "../../../assets/images/I2P_Logo.png";
import { makeStyles } from "@material-ui/styles";
import TablePagination from "@mui/material/TablePagination";
import { dashboardStyle } from "../../Invoices/Components/InvoiceDetails/style";
import { FormatAmount } from "../FormatAmount";
import moment from "moment";
import * as XLSX from "xlsx";
import axios from "axios";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";
import { handleInvoiceClick } from "../CommonLink";
import EmptyData from "../../../StyledComponents/Table/EmptyData";
import { getRefrenceDataList } from "../../Invoices/actions";
import Locadata from "./localData";
const useStyles = makeStyles(dashboardStyle, {
  tabCon: {
    "@media (max-width: 1580px)": {
      width: "max-content !important",
      textAlign: "center",
      // backgroundColor:'pink !important'
    },
  },
});

const FormatDate = (dateString) => {
  if (!dateString) return null;
  const parsedDate = moment(dateString);
  const formattedDate = parsedDate.format("DD MMM YYYY");
  return formattedDate;
};

const defaultFormValues = {
  RowsOfPage: 25,
  PageNo: 1,
  venderName: "All",
  Vendor: {
    Vendor_Code: "-1",
    Vendor_Name: "",
  },
  vendorCode: undefined,
  saleTaxICFilter: undefined,
  ITWCodeFilter: undefined,
  STWCodeFilter: undefined,
  invoice_Type: "",
  sortColumn: undefined,
  startDate: moment().startOf("month").format("YYYY-MM-DD"),
  endDate: moment().format("YYYY-MM-DD"),
  isAsc: false,
};
const defaultFormValuesDownload = {
  vendorName: undefined,
  Vendor: {
    Vendor_Code: "-1",
    Vendor_Name: "",
  },
  vendorCode: undefined,
  saleTaxICFilter: undefined,
  ITWCodeFilter: undefined,
  STWCodeFilter: undefined,
  invoice_Type: "",
  sortColumn: undefined,
  startDate: moment().startOf("month").format("YYYY-MM-DD"),
  endDate: moment().format("YYYY-MM-DD"),
  isAsc: false,
  isPdf: false,
};
const TaxI2pToSapTable = ({
  header,
  dropdownValue,
  loading,
  setData,
  setLoading,
  data,
  page,
}) => {
  console.log("dataList", data);
  const [filteredData, setFilteredData] = useState(data);
  const [ReturedBy, setReturedBy] = useState("");
  const [filterStates, setfilterStates] = useState({});
  const classes = useStyles();
  const [count, setCount] = useState(0);
  console.log(count, "count");
  const [formState, setFormState] = useState(
    defaultFormValues || defaultFormValuesDownload
  );
  const [vendors, setVendors] = useState([]);
  const [vendorLoading, setVendorLoading] = useState(false);
  const [expandedRowIndices, setExpandedRowIndices] = useState([]);
   const [multipleData, setMultipleData] = useState({
    invoice_Type: [],
  });

  const handleRowClick = (index) => {
    const updatedExpandedRowIndices = [...expandedRowIndices];

    if (updatedExpandedRowIndices.includes(index)) {
      // Double-click on an expanded row: collapse it
      const indexOfExpandedRow = updatedExpandedRowIndices.indexOf(index);
      updatedExpandedRowIndices.splice(indexOfExpandedRow, 1);
    } else {
      // Double-click on a non-expanded row: expand it
      updatedExpandedRowIndices.push(index);
    }

    setExpandedRowIndices(updatedExpandedRowIndices);
  };
  const mergeSapEntries = (sapItems) => {
    const mergedItem = {};

    sapItems.forEach((item) => {
      for (const key in item) {
        if (item.hasOwnProperty(key)) {
          if (!mergedItem[key]) {
            // Initialize if not already present
            mergedItem[key] = item[key];
          } else if (mergedItem[key] !== item[key]) {
            // If value differs, concatenate the values
            mergedItem[key] = `${mergedItem[key]}, ${item[key]}`;
          }
        }
      }
    });

    return mergedItem;
  };
  const fetchData = async (params) => {
   
    setfilterStates(params)
    const selectedEndDate = new Date(params.endDate);
    const selectedStartDate = new Date(params.startDate);

    if (isDateRangeExceedsThreeMonths(selectedStartDate, selectedEndDate)) {
      window.alert("The date range should not exceed 3 months.");
    } else{
      setLoading(true);
    await axios({
      method: "post", //you can set what request you want to be
      // url: `${process.env.REACT_APP_API_URL}/api/Role/GetUserList_v2/${user}`,
      url: `${process.env.REACT_APP_API_URL}/api/Report/GetTaxI2PToSAP`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
      data: [
        {
          doC_MIRO: "string",
          doC_MIRO_FY: "string",
        },
      ],
      params: {
        pageNumber: params?.PageNo || 1,
        pageSize: params?.RowsOfPage || 25,
        vendorCode: params?.vendorCode || undefined,  // Only include if it's not undefined or null
        vendorName:  (params?.Vendor?.Vendor_Name === "All" ||    params?.Vendor?.Vendor_Name === "" ) ? undefined  :   params?.Vendor?.Vendor_Name,  // Remove if 'All'
        STICode: params?.saleTaxICFilter || undefined,  
        ITWCode: params?.ITWCodeFilter || undefined,   
        STWCode: params?.STWCodeFilter || undefined,  
        invoiceType : params?.invoice_Type === "" ? undefined :  params?.invoice_Type, 
        fromDate: params?.startDate ? moment(params.startDate).format("MM/DD/YYYY") : undefined,  // Conditionally format the date
        toDate: params?.endDate ? moment(params.endDate).format("MM/DD/YYYY") : undefined  // Conditionally format the date
      }
    })
      .then(async (res) => {
        const {
          sapResponse,
          i2PResponse,
          totalCount,
          totalPages,
          currentPage,
          pageSize,
        } = res.data;
  
        const sapMergeForTaxCode = mergeDuplicateSapRecords(sapResponse)
        console.log(sapMergeForTaxCode,"sapMergeForTaxCode")
        const mergedData = i2PResponse
          .map((i2PItem) => {
            const miroValues = i2PItem.doC_MIRO
              .split(",")
              .map((value) => value.trim());
            console.log(miroValues, "miroValues");

            // Initialize an empty array to hold the final merged result
            let matchedRecords = [];
            // Set to track matched miro values
            let matchedMiroValues = new Set();
            // Only attempt to match if mergedSapResponse is not empty
            if (sapResponse.length > 0) {
              // Loop through each miroValue and attempt to match with the mergedSapResponse
              miroValues.forEach((miroValue, index) => {
                if (matchedMiroValues.has(miroValue)) return;
                // Find a matching sapItem in mergedSapResponse for each miroValue
                const matchedSapItem = sapMergeForTaxCode.find(
                  (sapItem) =>
                    ((miroValue.includes(sapItem.doC_INV) &&
                      i2PItem.doC_MIRO_FY === sapItem.doC_INV_FY) &&
                      (i2PItem.vendorCode === sapItem.vendoR_CODE && 
                        i2PItem.invoiceNo === sapItem.inV_NO))
                    // (i2PItem.vendorCode === sapItem.vendoR_CODE &&
                    //   sapItem.doC_MIRO === "")
                );

                // If a match is found, and has many matcing vendor code item from sap then  merge and concatinate and push it to the result array
                if (matchedSapItem) {
                  // const mergedAndConItems = mergeSapEntries(matchedSapItem);
                  console.log(
                    `Matched SAP item found for miroValue ${miroValue}:`,
                    matchedSapItem
                  );
                  console.log(matchedSapItem,"matchedSapItem")
                  matchedRecords.push({
                    ...i2PItem,
                    ...matchedSapItem,

                    vendorCode: matchedSapItem.vendoR_CODE,
                    vendorName: matchedSapItem.vendoR_NAME,
                  });
                }
                matchedMiroValues.add(miroValue);
              });

              // If no matches found after looping, return the original i2PItem unmerged
              if (matchedRecords.length === 0) {
                matchedRecords.push(i2PItem);
              }
            } else {
              // If sapResponse is empty, return i2PItem without merging
              matchedRecords.push(i2PItem);
            }

            // Return all matched records for this i2PItem (flattened)
            return matchedRecords;
          })
          .flat(); // Flatten the array if there are multiple matched records for one i2PItem
        const finalMergedRecords =
          sapResponse.length > 0
            ? mergeDuplicateSapRecords(mergedData)
            : mergedData;
        setData({
          totalCount,
          totalPages,
          currentPage,
          pageSize,
          sapMergeForTaxCode,
          i2PResponse,
          mergedData: mergedData,
        });
        // setCount(res?.data?.totalCount);
        // setCount(data?.mergedData?.length);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);

        setData({
          totalCount: 0,
          totalPages: 1,
          currentPage: 1,
          pageSize: 25,
          sapResponse: [],
          i2PResponse: [],
          mergedData: [],
        });
        setLoading(false);

        // setErrorMessage("Invalid username or password");
      });
    }
  };
  // const mergeDuplicateSapRecords = (sapResponse) => {
  //   console.log(sapResponse,"sapResponse")
  //   const mergedRecords = [];
  //   const concatenationKeys = ["itW_AMT", "itW_CODE", "stI_AMT", "stI_CODE", "stW_AMT", "stW_CODE"];
  
  //   sapResponse.forEach((record) => {
  //     const existingRecord = mergedRecords.find(
  //       (r) => r.vendorCode === record.vendorCode
  //     );
  
  //     // Check if the record has any keys from the concatenationKeys list
  //     const hasConcatenationKeys = Object.keys(record).some((key) =>
  //       concatenationKeys.includes(key)
  //     );
  
  //     if (existingRecord) {
  //       // If the record has concatenation keys, merge those values
  //       if (hasConcatenationKeys) {
  //         Object.keys(record).forEach((key) => {
  //           if (concatenationKeys.includes(key)) {
  //             // If the key exists and is different, concatenate the values
  //             if (existingRecord[key] && existingRecord[key] !== record[key]) {
  //               existingRecord[key] = `${existingRecord[key]}, ${record[key]}`;
  //             } else {
  //               existingRecord[key] = record[key];
  //             }
  //           }
  //         });
  //       } else {
  //         // If no concatenation keys, add the entire record as is
  //         mergedRecords.push({ ...record });
  //       }
  //     } else {
  //       // If the record does not already exist, simply add it to mergedRecords
  //       mergedRecords.push({ ...record });
  //     }
  //   });
  
  //   console.log(mergedRecords, "mergedRecords");
  //   return mergedRecords;
  // };
  
//   const mergeDuplicateSapRecords = (sapResponse) => {
//     const mergedRecords = [];
// console.log(sapResponse,"sapResponse")
//     sapResponse.forEach((record) => {
//       const existingRecord = mergedRecords.find(
//         (r) =>
//           // r.doC_MIRO === record.doC_MIRO
//           r.vendorCode === record.vendorCode
//         //  ( (r.doC_INV === record.doC_INV && r.doC_INV_FY === record.doC_INV_FY) || r.doC_MIRO === record.doC_MIRO )
//       );

//       if (existingRecord) {
//         Object.keys(record).forEach((key) => {
//           if (existingRecord[key] && existingRecord[key] !== record[key]) {
//             existingRecord[key] = `${existingRecord[key]}, ${record[key]}`;
//           } else {
//             existingRecord[key] = record[key];
//           }
//         });
//       } else {
//         mergedRecords.push({ ...record });
//       }
//     });
//     console.log(mergedRecords, "mergedRecords");
//     return mergedRecords;
//   };
const mergeDuplicateSapRecords = (sapResponse) => {
  console.log(sapResponse, "sapResponse");
  const mergedRecords = [];
  const concatenationKeys = ["itW_AMT", "itW_CODE", "stI_AMT", "stI_CODE", "stW_AMT", "stW_CODE"];

  sapResponse.forEach((record) => {
    const existingRecord = mergedRecords.find((r) => r.inV_NO === record.inV_NO);

    if (existingRecord) {
      // Loop through each key in the record
      Object.keys(record).forEach((key) => {
        if (concatenationKeys.includes(key)) {
          // If the key exists and values are different, concatenate with comma
          if (existingRecord[key] && existingRecord[key] !== record[key]) {
            existingRecord[key] = `${existingRecord[key]}, ${record[key]}`;
          } else {
            // If values are the same or the existing key is empty, assign the value directly
            existingRecord[key] = record[key];
          }
        } else if (existingRecord[key] !== record[key] && !concatenationKeys.includes(key)) {
          // For non-concatenation keys with different values, concatenate with comma
          existingRecord[key] = `${existingRecord[key]}, ${record[key]}`;
        }
      });
    } else {
      // If the record does not already exist, add it to mergedRecords
      mergedRecords.push({ ...record });
    }
  });

  console.log(mergedRecords, "mergedRecords");
  return mergedRecords;
};

  const resetFilter = async () => {
    setFormState(defaultFormValues);
    await fetchData(defaultFormValues);
  };
  console.log("latest", data);
  const [userList, setUserList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const handleChangePage = (event, newPage) => {
    setFormState((formState) => ({
      ...formState,
      PageNo: newPage + 1,
    }));
  };

  const handleChangeRowsPerPage = (event) => {
    setFormState((formState) => ({
      ...formState,
      RowsOfPage: event.target.value,
    }));
  };
  useEffect(() => {
    if(formState?.Vendor?.Vendor_Name !== "" ){  
    fetchData(formState);
    }
  }, [
    formState?.PageNo,
    formState?.RowsOfPage,
    formState.sortColumn,
    formState.isAsc,
  ]);
      useEffect(() => {
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => { },
      setMultipleData
    );

  }, [])
  useEffect(() => {
    setCount(data?.mergedData?.length);
  }, [data?.mergedData]);
  const handleSort = (columnIndex) => {
    if (columnIndex === formState.sortColumn) {
      setFormState((prevState) => ({
        ...prevState,
        isAsc: !formState.isAsc,
      }));
    } else {
      setFormState((prevState) => ({
        ...prevState,
        sortColumn: columnIndex,
        isAsc: true,
      }));
    }
  };
  const fetchUserList = async (query) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getVendorDetails/${
          query ? query : null
        }`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        }
      );
      setUserList(response.data);
    } catch (error) {
      console.log(error);
    }
  };

    useEffect(() => {
      fetchData(formState);
    }, [
      formState?.PageNo,
      formState?.RowsOfPage,
      formState.sortColumn,
      formState.isAsc,
    ]);
  const handleSearchChange = (event, value) => {
    setSearchQuery(value);
  };

  useEffect(() => {
    if (searchQuery.trim() !== "") {
      fetchUserList(searchQuery);
    } else {
      fetchUserList();
    }
  }, [searchQuery]);
  // State for Excel download loading

  // const handleDownloadFile = async (params, fileType) => {
  //   if (fileType === "pdf") {
  //     setIsPdfLoading(true);
  //   } else if (fileType === "excel") {
  //     setIsExcelLoading(true);
  //   }

  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_URL}/api/Report/DownloadI2PTOTAX`,
  //       {
  //         responseType: "blob",
  //         params: {
  //           vendorCode: params?.vendorCode,
  //           vendorName:
  //             params?.venderName === "All" ? undefined : params?.venderName,
  //           STICode: params.saleTaxICFilter,
  //           ITWCode: params.ITWCodeFilter,
  //           STWCode: params.STWCodeFilter,
  //           sortColumn: params?.sortColumn,
  //           fromDate: params.startDate,
  //           toDate: params.endDate,
  //           isAsc: params?.isAsc,
  //           isPdf: fileType === "pdf",
  //         },
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${localStorage.getItem("user_token")}`,
  //         },
  //       }
  //     );
  //     const blob = new Blob([response.data], {
  //       type:
  //         fileType === "pdf"
  //           ? "application/pdf"
  //           : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });

  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute(
  //       "download",
  //       fileType === "pdf" ? `TaxI2pToSap.pdf` : "TaxI2pToSap.xlsx"
  //     );
  //     document.body.appendChild(link);
  //     link.click();
  //     if (fileType === "pdf") {
  //       setIsPdfLoading(false);
  //     } else if (fileType === "excel") {
  //       setIsExcelLoading(false);
  //     }
  //   } catch (error) {
  //     console.error(`Error downloading ${fileType} file:`, error);
  //     if (fileType === "pdf") {
  //       setIsPdfLoading(false);
  //     } else if (fileType === "excel") {
  //       setIsExcelLoading(false);
  //     }
  //   }
  // };
  const [isPdfLoading, setIsPdfLoading] = useState(false); // State for PDF download loading
  const [isExcelLoading, setIsExcelLoading] = useState(false);
  console.log(formState, "formState");
  const handleDownloadExcel = () => {
    setIsExcelLoading(true); // Set loading to true when download starts

    const headers = [
      { label: "Vendor Code", key: "vendorCode" },
      { label: "Vendor Name", key: "vendorName" },
      { label: "Invoice No", key: "invoiceNo" },
      { label: "Invoice Date", key: "inV_DATE" },
      { label: "Invoice Amount", key: "inV_AMOUNT", align: "right" },
      { label: "Sales Tax Input Code", key: "i2PSalesTaxCode", section: "I2P" },
      {
        label: "Sales Tax Input Amount",
        key: "i2PSalesTaxAmount",
        section: "I2P",
        align: "right",
      },
      { label: "ITW Code", key: "i2PITWCode", section: "I2P" },
      {
        label: "ITW Amount",
        key: "i2PITWAmount",
        section: "I2P",
        align: "right",
      },
      { label: "STW Code", key: "i2PSTWCode", section: "I2P" },
      {
        label: "STW Amount",
        key: "i2PSTWAmount",
        section: "I2P",
        align: "right",
      },
      { label: "Sales Tax Input Code", key: "stI_CODE", section: "SAP" },
      {
        label: "Sales Tax Input Amount",
        key: "stI_AMT",
        section: "SAP",
        align: "right",
      },
      { label: "ITW Code", key: "itW_CODE", section: "SAP" },
      { label: "ITW Amount", key: "itW_AMT", section: "SAP", align: "right" },
      { label: "STW Code", key: "stW_CODE", section: "SAP" },
      { label: "STW Amount", key: "stW_AMT", section: "SAP", align: "right" },
      { label: "SAP Posting ID", key: "doC_INV", section: "SAP" },
      { label: "Cheque No", key: "chequE_NO", section: "SAP" },
      { label: "Cheque Date", key: "chequE_DATE", section: "SAP" },
      {label : "Invoice Type" , key: "invoiceType" , section: "SAP"}
    ];

    // Function to generate applied filter text
    const getFilterText = (formState) => {
      const filters = [];
      if (formState.vendorCode)
        filters.push(`Vendor Code: ${formState.vendorCode}`);
      if (formState.vendorName)
        filters.push(`Vendor Name: ${formState.vendorName}`);
      if (formState.saleTaxICFilter)
        filters.push(`STI Code: ${formState.saleTaxICFilter}`);
      if (formState.ITWCodeFilter)
        filters.push(`ITW Code: ${formState.ITWCodeFilter}`);
      if (formState.STWCodeFilter)
        filters.push(`STW Code: ${formState.STWCodeFilter}`);
      if (formState.invoice_Type)
        filters.push(`Invoice Type: ${formState.invoice_Type}`);
      if (formState.startDate)
        filters.push(`Start Date: ${formState.startDate}`);
      if (formState.endDate) filters.push(`End Date: ${formState.endDate}`);
      return filters.length > 0 ? filters.join(" | ") : "No Filters Applied";
    };
    const filterText = getFilterText(filterStates);

    const filteredData = data?.mergedData?.map((item) => {
      const filteredItem = {};
      headers.forEach((header) => {
        if (header.key === "chequE_DATE" && item[header.key]) {
          filteredItem[header.key] =
            item[header.key]
              .split(",")
              .map((value) => FormatDate(value.trim()))
              .join(", ") || ""; // Apply date format
        } else {
          filteredItem[header.key] = item[header.key];
        }
      });
      return filteredItem;
    });

    // Prepare the worksheet with applied filters at the top
    const worksheet = XLSX.utils.json_to_sheet([]);

    // Insert the applied filters at the top
    XLSX.utils.sheet_add_aoa(worksheet, [[`Applied Filters: ${filterText}`]], {
      origin: "A1",
    });

    // Insert the header row below the filters
    XLSX.utils.sheet_add_aoa(
      worksheet,
      [headers.map((header) => header.label)],
      { origin: "A3" }
    );

    // Add the filtered data starting from row 4
    XLSX.utils.sheet_add_json(worksheet, filteredData, {
      origin: "A4",
      skipHeader: true,
    });

    // Create a new workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(workbook, "TaxI2pToSap.xlsx");

    setTimeout(() => {
      setIsExcelLoading(false);
    }, 2000);
  };

  const handleDownloadPDF = () => {
    console.log("downloading....");
    setIsPdfLoading(true);

    const headers = [
      "No #",
      "Vendor Code",
      "Vendor Name",
      "Invoice No",
      "Invoice Amount",
      "I2P-Sales Tax Input Code",
      "I2P-Sales Tax Input Amount",
      "I2P-ITW Code",
      "I2P-ITW Amount",
      "I2P-STW Code",
      "I2P-STW Amount",
      "SAP-Sales Tax Input Code",
      "SAP-Sales Tax Input Amount",
      "SAP-ITW Code",
      "SAP-ITW Amount",
      "SAP-STW Code",
      "SAP-STW Amount",
      "SAP Posting ID",
      "Cheque No",
      "Cheque Date",
      "Invoice Type"
    ];

    const doc = new jsPDF({
      orientation: "landscape", // Set landscape mode for more horizontal space
      unit: "pt", // Unit in points
      format: "A4", // A4 page size
    });

    // Add the logo
    doc.addImage(Logo, "PNG", 10, 10, 50, 50); // Adjusted for better size

    // Add filter information
    let yPosition = 60; // Start position for filters
    doc.setFontSize(10);
    doc.text("Applied Filters:", 10, yPosition);
    yPosition += 17;

    // Generate filter text dynamically
    const getFilterText = (formState) => {
      const filters = [];
      if (formState.vendorCode)
        filters.push(`Vendor Code: ${formState.vendorCode}`);
      if (formState.vendorName)
        filters.push(`Vendor Name: ${formState.vendorName}`);
      if (formState.saleTaxICFilter)
        filters.push(`STI Code: ${formState.saleTaxICFilter}`);
      if (formState.ITWCodeFilter)
        filters.push(`ITW Code: ${formState.ITWCodeFilter}`);
      if (formState.STWCodeFilter)
        filters.push(`STW Code: ${formState.STWCodeFilter}`);
       if (formState.invoice_Type)
        filters.push(`Invoice Type: ${formState.invoice_Type}`);
      if (formState.startDate)
        filters.push(`Start Date: ${formState.startDate}`);
      if (formState.endDate) filters.push(`End Date: ${formState.endDate}`);

      return filters.length > 0 ? filters.join(" | ") : "No Filters Applied";
    };
    const filterText = getFilterText(filterStates);
    doc.text(filterText, 10, yPosition);
    // Add the "I2P-Tax code I2P TO SAP" title and center it above the table
    doc.setFontSize(14);
    doc.text(
      "I2P-Tax code I2P TO SAP",
      doc.internal.pageSize.getWidth() / 2,
      35,
      { align: "center" }
    );
    // Add the table
    doc.autoTable({
      head: [headers], // Use header labels
      body: data?.mergedData?.map((item, index) => [
        index + 1,
        item.vendorCode || "",
        item.vendorName || "",
        item.invoiceNo || "",
        item.invoiceAmount || "",
        item.i2PSalesTaxCode || "",
        item.i2PSalesTaxAmount || "",
        item.i2PITWCode || "",
        item.i2PITWAmount || "",
        item.i2PSTWCode || "",
        item.i2PSTWAmount || "",
        item.stI_CODE || "",
        item.stI_AMT || "",
        item.itW_CODE || "",
        item.itW_AMT || "",
        item.stW_CODE || "",
        item.stW_AMT || "",
        item.doC_INV || "",
        item.chequE_NO || "",
        item.chequE_DATE
          ?.split(",")
          .map((value) => FormatDate(value.trim()))
          .join(", ") || "",
          item.invoiceType
      ]),
      startY: yPosition + 20, // Start table after filter information
      theme: "plain", // Plain theme for no background color in header
      styles: {
        fontSize: 8, // Adjust font size
        cellPadding: 4, // Cell padding for better spacing
        halign: "center", // Center align text in all cells
        valign: "middle", // Vertically align to middle
        lineWidth: 0.1, // Add border to cells
        lineColor: [0, 0, 0], // Border color
      },
      headStyles: {
        fillColor: [255, 255, 255], // No background color for header
        textColor: [0, 0, 0], // Black text color for header
        halign: "center", // Center align header text
        lineWidth: 0.1, // Add border to header cells
        lineColor: [0, 0, 0], // Border color for header
      },
      columnStyles: {
        0: { cellWidth: "auto" }, // Auto width for columns to fill the page
      },
      didDrawCell: (data) => {
        if (data.row.index === 0 && data.column.index === 0) {
          doc.setFontSize(10); // Adjust font size for specific cells if needed
        }
      },
    });

    // Save the PDF
    doc.save("I2P_Tax_to_SAP.pdf");

    setTimeout(() => {
      setIsPdfLoading(false); // Set loading to false after the simulated delay
    }, 2000);
  };

  const i2pHeaders = header.filter((h) => h.section === "I2P");
  const sapHeaders = header.filter((h) => h.section === "SAP");
  // one month validation
  // const handleStartDateChange = (e) => {
  //   const selectedStartDate = e.target.value;
  //   const startDateMonth = new Date(selectedStartDate).getMonth();

  //   // Restrict the end date to the same month
  //   if (formState.endDate) {
  //     const endDateMonth = new Date(formState.endDate).getMonth();
  //     if (endDateMonth !== startDateMonth) {
  //       setFormState((x) => ({
  //         ...x,
  //         endDate: "", // Clear the end date if it's not in the same month
  //       }));
  //     }
  //   }

  //   setFormState((x) => ({
  //     ...x,
  //     startDate: selectedStartDate,
  //   }));
  // };

  // const handleEndDateChange = (e) => {
  //   const selectedEndDate = e.target.value;
  //   const startDateMonth = new Date(formState.startDate).getMonth();
  //   const endDateMonth = new Date(selectedEndDate).getMonth();

  //   // Only allow setting the end date if it's in the same month as the start date
  //   if (startDateMonth === endDateMonth) {
  //     setFormState((x) => ({
  //       ...x,
  //       endDate: selectedEndDate,
  //     }));
  //   } else {
  //     // Optionally, show an alert or some feedback to the user
  //     window.alert("End date must be in the same month as the start date.");
  //   }
  // };

  // 3 month validation
  const handleStartDateChange = (e) => {
    const selectedStartDate = new Date(e.target.value);
    const selectedEndDate = new Date(formState.endDate);

    if (
      formState.endDate &&
      isDateRangeExceedsThreeMonths(selectedStartDate, selectedEndDate)
    ) {
      window.alert("The date range should not exceed 3 months.");
    } else {
      setFormState((x) => ({
        ...x,
        startDate: e.target.value,
      }));
    }
  };

  const handleEndDateChange = (e) => {
    const selectedEndDate = new Date(e.target.value);
    const selectedStartDate = new Date(formState.startDate);

    if (isDateRangeExceedsThreeMonths(selectedStartDate, selectedEndDate)) {
      window.alert("The date range should not exceed 3 months.");
    } else {
      setFormState((x) => ({
        ...x,
        endDate: e.target.value,
      }));
    }
  };

  const isDateRangeExceedsThreeMonths = (startDate, endDate) => {
    if (!startDate || !endDate) return false;

    let diffInMonths =
      (endDate.getFullYear() - startDate.getFullYear()) * 12 +
      (endDate.getMonth() - startDate.getMonth());

    console.log(diffInMonths, "diffInMonths");
    // If the day of the end date is greater then the start date, subtract + month
    if (endDate.getDate() > startDate.getDate()) {
      diffInMonths++;
    }

    return diffInMonths > 3;
  };

  
  const autocompleteChangeHandler = (name, value) => {
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
    const updatedFormState = {
      ...formState,
      [name]: value,
    };

  };

   useEffect(() => {
      if (vendors.length > 0 && vendors[0].Vendor_Code !== "-1") {
        const vendorsStrigify = JSON.stringify(vendors);
        const vendorsParse = JSON.parse(vendorsStrigify);
        vendorsParse.unshift({ Vendor_Code: "-1", Vendor_Name: "All" });
        setVendors(vendorsParse);
      }
    }, [vendors]);


      useEffect(() => {
        getVendorDetail(null, setVendors, setVendorLoading);
      
      }, []);

    const getVendorDetail = async (user, setUserData, setLoading) => {
      setLoading(true);
      //
      await axios({
        method: "get", //you can set what request you want to be
        url: `${
          process.env.REACT_APP_API_URL
        }/api/InvoiceDetails/getVendorDetails/${user ? user : null}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
      })
        .then(async (res) => {
          setUserData(res.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
    
          // setErrorMessage("Invalid username or password");
        });
    };

  return (
    <div>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Typography>Vendor Name:</Typography>
        
<Autocomplete
                    // sx={{
                    //   "& .MuiInputBase-root": {
                    //     height: "30px",
                    //     textAlign: "center",
                    //     display: "flex",
                    //     alignItems: "center",
                    //   },
                    //   "& .MuiInputBase-input": {
                    //     marginTop: "-4px", // Adjust this value to move the text up
                    //     fontSize: 15,
                    //   },
                    // }}
                    id="Vendor"
                    options={vendors}
                    classes={{ option: classes.option }}
                    size="small"
                    name="Vendor"
                    value={formState.Vendor}
                    getOptionLabel={(option) =>
                      (option !== "" &&
                        `${
                          option?.Vendor_Code !== "-1"
                            ? `${option?.Vendor_Code}-`
                            : ""
                        }${option?.Vendor_Name}`) ||
                      ""
                    }
                    loading={vendorLoading}
                    onChange={(event, newValue) => {
                      autocompleteChangeHandler("Vendor", newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        // sx={{ input: { color: "#888888" } }}
                        {...params}
                        name=""
                        required
                        value={""}
                        onChange={(event) => {
                          getVendorDetail(
                            event.target.value,
                            setVendors,
                            setVendorLoading
                          );
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
        </Grid>

        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Typography>Vendor Code :</Typography>
          <TextField
            variant="outlined"
            value={formState?.vendorCode || ""}
            onChange={(e) => {
              setFormState((x) => ({
                ...x,
                vendorCode: e?.target?.value,
              }));
            }}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Typography>Sale Tax Input Code :</Typography>
          <TextField
            variant="outlined"
            value={formState.saleTaxICFilter || ""}
            onChange={(e) => {
              setFormState((x) => ({
                ...x,
                saleTaxICFilter: e?.target?.value,
              }));
            }}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Typography>ITW Code:</Typography>
          <TextField
            variant="outlined"
            value={formState.ITWCodeFilter || ""}
            onChange={(e) => {
              setFormState((x) => ({
                ...x,
                ITWCodeFilter: e?.target?.value,
              }));
            }}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Typography>STW Code:</Typography>
          <TextField
            variant="outlined"
            value={formState.STWCode || ""}
            onChange={(e) => {
              setFormState((x) => ({
                ...x,
                STWCode: e?.target?.value,
              }));
            }}
            fullWidth
            size="small"
          />
        </Grid>
         <Grid item
          xs={12}
          sm={12}
          md={2}
          lg={2}>
          <Typography style={{ color: "black" }}>
            Invoice Type:
          </Typography>
          <Autocomplete

            id="submitter_role"
            options={
              multipleData?.invoice_Type
            }
            size="small"
            value={{
              ReferenceCode: formState?.invoice_Type || "",
            }}
            //  disabled={disable}
            title="select select"
            getOptionLabel={(option) =>
              (option !== "" &&
                `${option?.ReferenceCode}`) ||
              ""
            }
            // loading={rolesLoading}
            onChange={(event, newValue) => {

              autocompleteChangeHandler("invoice_Type", newValue?.ReferenceCode);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                type="text"
                name=""
                placeholder="Select a value"
                required={formState?.isProceed}
              />
            )}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={0} mb={5}>
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Typography>
            Start Date:
          </Typography>
          <TextField
            type="date"
            variant="outlined"
            fullWidth
            size="small"
            value={formState.startDate || ""}
            // onChange={handleStartDateChange}
            onChange={(e) => {
              setFormState((x) => ({
                ...x,
                startDate: e.target.value,
              }));
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Typography>
            End Date:
          </Typography>
          <TextField
            fullWidth
            size="small"
            type="date"
            variant="outlined"
            value={formState.endDate || ""}
            // onChange={handleEndDateChange}
            onChange={(e) => {
              setFormState((x) => ({
                ...x,
                endDate: e.target.value,
              }));
            }}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: "10px" }}
          />
          <Typography>
            Note: You can only select a date range of 3 months for better
            performance.
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={8} lg={8}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={() => fetchData(formState)}
              >
                Filter
              </Button>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={resetFilter}
              >
                Reset Filter
              </Button>
            </div>
            <div>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={handleDownloadExcel}
                disabled={isExcelLoading || loading}
              >
                {isExcelLoading ? "Downloading.." : "Download Excel"}
              </Button>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={() => handleDownloadPDF()}
                disabled={isPdfLoading || loading}
              >
                {isPdfLoading ? "Downloading.." : "PDF Download"}
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        // style={{ width: "0", zIndex: "0" }}
      >
        <TableContainer
          className="scrollable"
          // style={{width: "1250px", height:"500px", overflowX: "auto" }}
        >
          <Table style={{ minWidth: "1200px", height: "400px" }}>
            <TableHead>
              <TableRow>
                <TableCell colSpan={5}></TableCell>
                <TableCell
                  colSpan={i2pHeaders?.length}
                  style={{ backgroundColor: "#FFD700", textAlign: "center" }}
                >
                  I2P
                </TableCell>
                <TableCell
                  colSpan={sapHeaders?.length}
                  style={{ backgroundColor: "#90EE90", textAlign: "center" }}
                >
                  SAP
                </TableCell>
              </TableRow>
              <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                {header.map((header, index) => (
                  <TableCell
                  // style={{
                  //   backgroundColor:
                  //     header.section === "I2P" ? "#FFD700" : "#EFF2F4",
                  // }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "left",
                        justifyContent: "left",
                        cursor: "pointer",
                      }}
                    >
                      {header.label}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  {[...Array(header.length)].map((header, colIndex) => (
                    <TableCell key={colIndex}>
                      <Skeleton
                        variant="rectangular"
                        style={{ height: 48, marginBottom: "10px" }}
                      />
                      <Skeleton
                        variant="rectangular"
                        style={{ height: 48, marginBottom: "10px" }}
                      />{" "}
                      <Skeleton
                        variant="rectangular"
                        style={{ height: 48, marginBottom: "10px" }}
                      />{" "}
                      <Skeleton
                        variant="rectangular"
                        style={{ height: 48, marginBottom: "10px" }}
                      />{" "}
                      <Skeleton
                        variant="rectangular"
                        style={{ height: 48, marginBottom: "10px" }}
                      />{" "}
                      <Skeleton
                        variant="rectangular"
                        style={{ height: 48, marginBottom: "10px" }}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              ) : data?.mergedData?.length <= 0 ? (
                <TableCell colSpan={19}>
                  <EmptyData />
                </TableCell>
              ) : (
                data?.mergedData
                  ?.slice(
                    (formState.PageNo - 1) * formState.RowsOfPage,
                    formState.PageNo * formState.RowsOfPage
                  )
                  .map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {header.map((header, colIndex) => (
                        <TableCell
                          key={colIndex}
                          align={
                            header.key === "invoiceAmount" ? "right" : "left"
                          }
                        >
                          {header.key === "invoiceNo" ? (
                            <div
                              onClick={() =>
                                handleInvoiceClick(
                                  row?.role,
                                  row?.status,
                                  row?.invoiceID,
                                  row?.vendoR_CODE
                                )
                              }
                              style={{
                                color: "blue",
                                cursor: "pointer",
                                textDecoration: "underline",
                              }}
                            >
                              {row[header.key]}
                            </div>
                          ) : header.key === "inV_DATE" ||
                            header.key === "chequE_DATE" ||
                            header.key === "submissionDate" ? (
                            // FormatDate(row[header.key])
                            row[header.key]
                              ?.split(",")
                              .map((value) => FormatDate(value.trim()))
                              .join(", ") // Format the date
                          ) : header.key === "inV_AMOUNT" || 
                          header.key === "i2PSalesTaxAmount" ||
                          header.key === "i2PITWAmount"||
                          header.key === "i2PSTWAmount"||
                          header.key === "stI_AMT"||
                          header.key === "stW_AMT"||
                          header.key === "itW_AMT"
                            ? (!isNaN(parseFloat(row[header.key])) && row[header.key] !== null
                              ? FormatAmount(row[header.key])
                              : row[header.key]) : (
                              row[header.key]
                            )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <TablePagination
        rowsPerPageOptions={[25, 50, 100, 500, 1000]}
        component="div"
        count={count}
        rowsPerPage={formState.RowsOfPage}
        page={parseInt(formState.PageNo) - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default TaxI2pToSapTable;
